import { EmployeeSales, LocationSales, ProductsSold } from '../models';
import { DashboardFilter } from '../models/dashboard-filter';
import { IncomeSummary } from '../models';
import { Observable } from 'rxjs/Observable';
import { ApiService, ConfigService } from '../../../shared/services';
import { Injectable } from '@angular/core';
import { IBoundedContext } from '../../../config';

@Injectable()
export class DashboardService {
    private _bi: IBoundedContext;

    constructor(private _api: ApiService,
        private configService: ConfigService) {
            this._bi = this.configService.getContext('bi');
        }

    getIncomeSummary(filter: DashboardFilter): Observable<IncomeSummary> {
        return this._api.get(this._bi.url, 'managerial/income/summary', filter)
            .map(summary => new IncomeSummary(summary))
            .cache();
    }

    getEmployeeSales(filter: DashboardFilter): Observable<EmployeeSales[]> {
        return this._api.get(this._bi.url, 'employees/sales', filter)
            .map(sales => sales.data.map(sale => new EmployeeSales(sale)))
            .cache();
    }

    getSalesByLocation(filter: DashboardFilter): Observable<LocationSales[]> {
        return this._api.get(this._bi.url, 'reporting/mobile/sales/locations', filter)
            .map(sales => sales.map(sale => new LocationSales(sale)))
            .cache();
    }

    getProductsSoldByLocation(filter: DashboardFilter): Observable<ProductsSold[]> {
        return this._api.get(this._bi.url, 'inventory/sold', filter)
            .map(sold => sold.map(productsSold => new ProductsSold(productsSold)))
            .cache();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/dashboard/shared/services/dashboard.service.ts